import {
  Component,
  OnInit,
  OnDestroy
} from '@angular/core';

import { DomSanitizer } from '@angular/platform-browser'

import {
  Router,
  ActivatedRoute
} from '@angular/router';

import { FileService } from '../../services/file.service';
import { NotificationService } from '../../services/notification.service';
import { MessageService } from '../../services/message.service';
import { TranslateService } from '@ngx-translate/core';

import * as _ from 'lodash';

@Component({
  selector: 'view-file',
  templateUrl: './view-file.component.html',
  styleUrls: ['./view-file.component.scss']
})
export class ViewFileComponent implements OnInit, OnDestroy {
  error = null;
  file = null;
  private _putToken = null;
  filesToView = [];
  fileId = '';
  success = null;
  messages = [];
  mailToken = null;
  openMessages = false;
  working = false;
  fileViewUrls = [];
  selectedRowLinkedFiles: null;
  linkedfiles = null;
  tabindex = 0;
  subPID = null;

  table = {
    linkedfiles: { all: [], display: [] },
    pending: { all: [], display: [] },
  }


  private _sub;

  stringify(data) {
    return JSON.stringify(data);
  }

  constructor(private _router: Router, private _route: ActivatedRoute, private _fileService: FileService, private _notification: NotificationService,
    private _sanitizer: DomSanitizer, public translate: TranslateService, private _messageService: MessageService) {
    console.log("cons");

  }

  _reset() {
    this.error = null;
    this.success = null;
    this.file = null;
    this._putToken = null;
    this.filesToView = [];
    this.fileId = '';
  }

  viewFile() {

    console.log(this.fileId, this.mailToken, this.subPID);

    //console.log("params", params);

    this._fileService.getPublicInformation(this.fileId, this.subPID).subscribe(
      (file: any) => {
        console.log("have file", file._id, file.PID);
        this.file = file;
        this.translate.use(file.PID.PIDOwner.lang);
        document.documentElement.setAttribute("lang", file.PID.PIDOwner.lang);

        this._fileService.getViewFileURL(this.file.PID._id, this.file, this.mailToken)
          .subscribe(
            (ret: any) => {
              console.log("have file view", ret);
              this.linkedfiles = ret.linkedfiles;
              this.table.linkedfiles.all = this.linkedfiles.map(x => {
                x.PID = x.file.PID;
                x.name = x.file.name;
                x.type = x.file.type;
                x.job = x.file.job;
                x.description = x.file.description;
                x.deadline = x.file.deadline;
                return x;
              });
              this.table.linkedfiles.display = this.linkedfiles;

              if (ret.version) {
                this.file['version'] = ret.version;
                this.fileViewUrls = _.map(ret.version.files, (f, i) => {
                  return {
                    type: f['fileType'],
                    name: f['name'],
                    originalGetUrl: ret.urls[i],
                    url: ret.urls[i],
                    getUrl: this._sanitizer.bypassSecurityTrustResourceUrl(ret.urls[i]),
                    downloadUrl: this._sanitizer.bypassSecurityTrustUrl(ret.urls[i])
                  }
                });
              }
            },
            err => {
              this.error = "MESSAGE.ERROR.FILE_NOT_FOUND";
              this._notification.errorServer(err);
            });

      },
      err => this.error = "MESSAGE.ERROR.FILE_NOT_FOUND"
    )
  }

  goToLinkedFile = (f) => {
    //this.tabindex = 0;
    //this._router.navigate(['view-file', f.file._id, f.token, f.file.PID._id]).then(()=> this.tabindex = 0)

    this.fileId = f.file._id;
    this.mailToken = f.token;
    this.subPID = f.file.PID._id;

    this.viewFile();
    this.tabindex = 0;
  }

  selectRowLinkedFiles(obj, idx) {
    this.selectedRowLinkedFiles = idx;
  }

  ngOnDestroy() {
    this._sub.unsubscribe();
  }

  ngOnInit() {
    console.log("ng init");
    //noinspection TypeScriptValidateTypes

    this._sub = this._route.params.subscribe(params => {

      this.fileId = params['id'];
      this.mailToken = params['token'];
      this.subPID = params['subpid'];

      this.viewFile();

    });
  }


  fileChangeEvent(fileInput) {
    this.filesToView = fileInput.target.files;
    this._preview();
  }

  private _preview() {
    _.forEach(this.filesToView, file => {
      var reader = new FileReader();
      var _self = this;

      reader.addEventListener("load", function () {
        file.getUrl = _self._sanitizer.bypassSecurityTrustResourceUrl(reader.result as string);
      }, false);
      reader.readAsDataURL(file);
    })
  }



  getDownloadUrl(url) {
    return this._sanitizer.bypassSecurityTrustUrl(url);
  }



  private _setMessageDisplayInfo(message) {
    var date = new Date(message.updatedAt);
    message.content = message.content.split('\n').join('<br>');
    message.author = (message.from == this.file.PID.PIDOwner.email) ? this.file.PID.PIDOwner.name : 'DATA.YOU';
    message.side = (message.from == this.file.PID.PIDOwner.email) ? 'left' : 'right';
    message.updatedAt = date.getDate() + '-' + (date.getMonth() + 1) + '-' + date.getFullYear();
    return message;
  }

  getMessagePadding() {
    return '';
    //return this.openMessages ? '24px 24px 0 24px' : '0px';
  }

  sendMessage(content) {
    this._messageService.addContractorMessage(this.fileId, this.mailToken, content)
      .subscribe(message => {
        this.messages.push(this._setMessageDisplayInfo(message));
      });
  }
}
